import { render, staticRenderFns } from "./SegmentPills.vue?vue&type=template&id=1581a206&"
import script from "./SegmentPills.vue?vue&type=script&lang=js&"
export * from "./SegmentPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports